import { render } from "./SettingsArtist.vue?vue&type=template&id=0a570910"
import script from "./SettingsArtist.vue?vue&type=script&lang=js"
export * from "./SettingsArtist.vue?vue&type=script&lang=js"

import "./SettingsArtist.vue?vue&type=style&index=0&id=0a570910&lang=scss&scooped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__